export default __webpack_public_path__ + "static/media/Beramoniumbanner.6d1b982b.png";